import React from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import { LINKS } from 'src/routes';
import PageLayout from '@components/PageLayout';
import Breadcrumbs, {
  BreadcrumbsType,
} from '@components/Breadcrumbs/Breadcrumbs';
import { Heading, Text, Icon } from '@puppet/react-components';
import { useTranslation } from 'react-i18next';

const RootPeLayout = () => {
  const { t } = useTranslation('codeDelivery');
  const landingPage = !!useMatch(LINKS.root.puppetEnterprise);

  if (!landingPage) {
    return <Outlet />;
  }

  const breadcrumbs: BreadcrumbsType = [
    { displayName: t('root.accounts.breadcrumbs.root.console') },
    {
      displayName: t('addProtectedEnvironment.breadcrumbs.peIntegrationsPage'),
    },
  ];

  return (
    <PageLayout>
      <PageLayout.Header>
        <PageLayout.Breadcrumbs>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </PageLayout.Breadcrumbs>
        <Heading>
          {t('regenerateAuthToken.breadcrumbs.peIntegrationsPage')}
        </Heading>
        <div className="root-puppet-enterprise-integration">
          <Icon
            type="info-circle"
            size="small"
            className="root-puppet-enterprise-integration__icon"
          />
          <Text size="small" color="medium">
            {t('root.account.settings.puppetenterprise.description')}
          </Text>
        </div>
      </PageLayout.Header>
      <PageLayout.Content>
        <Outlet />
      </PageLayout.Content>
    </PageLayout>
  );
};

export default RootPeLayout;
